
export const TABLE_FIELDS = [
  {
    key: 'id',
    label: 'ID',
    sortable: false,
    thClass: 'table-header',
  },
  {
    key: 'partnerCode',
    label: 'Mã đối tác',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  },
  {
    key: 'partnerName',
    label: 'Tên đối tác',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  },
  {
    key: 'user',
    label: 'Người dùng',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  },
  {
    key: 'status',
    label: 'Trạng thái',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  },
  {
    key: 'createdBy',
    label: 'Người tạo',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  },
  {
    key: 'actions',
    label: 'Thao tác',
    sortable: false,
    tdClass: 'td-type',
    thClass: 'table-type-header',
  }
];
